import { useState } from "react";
import { Plus } from "lucide-react";
import { CaptureSheet } from "@/components/capture/CaptureSheet";

/**
 * HOTFIX-BW19.4 PR-A Bug 1: Capture trigger surfaces on /today.
 *
 * Renders both an inline button (replaces the BW19 Voice + Photo pair) and
 * a thumb-reachable floating button anchored bottom-right on mobile. Both
 * open the same CaptureSheet (Text default, Voice + Photo via tabs). The
 * global n shortcut continues to open the same sheet from AppShell.
 */

export function CaptureButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        aria-label="Capture inputs"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "var(--space-2)",
          padding: "var(--space-2)",
        }}
      >
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="Capture (text, voice, or photo)"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "10px 14px",
            background: "var(--chip)",
            color: "var(--fg)",
            border: "1px solid var(--hair)",
            borderRadius: "var(--radius-card)",
            fontFamily: "var(--font-sans)",
            fontSize: 14,
            cursor: "pointer",
          }}
        >
          <Plus size={18} strokeWidth={1.6} />
          <span>Capture</span>
          <kbd
            aria-hidden="true"
            style={{
              marginLeft: 4,
              padding: "2px 6px",
              background: "var(--bg-3)",
              color: "var(--fg-3)",
              border: "1px solid var(--hair)",
              borderRadius: 4,
              fontFamily: "var(--font-mono, monospace)",
              fontSize: 11,
            }}
          >
            n
          </kbd>
        </button>
      </div>

      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Capture"
        className="haus-capture-fab"
      >
        <Plus size={24} strokeWidth={1.8} />
      </button>
      <style>{`
        .haus-capture-fab {
          display: none;
          position: fixed;
          right: var(--space-4);
          bottom: calc(var(--bottomtab-h, 64px) + var(--space-4));
          width: 56px;
          height: 56px;
          align-items: center;
          justify-content: center;
          background: var(--accent, var(--fg));
          color: var(--bg);
          border: none;
          border-radius: 50%;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
          cursor: pointer;
          z-index: 40;
        }
        @media (max-width: 1023px) {
          .haus-capture-fab { display: inline-flex; }
        }
      `}</style>

      <CaptureSheet open={open} onClose={() => setOpen(false)} />
    </>
  );
}
